module.exports = __webpack_public_path__ + "img/card2.a660dca1.png";